import type { Match } from './api/types';

/**
 * How a poster is named throughout the app: "Top 5 v Grangemouth Railway". The headline is the
 * wording printed on the poster ("Good Luck"), which is not a name - several posters share it.
 * A poster with no fixture has no opponent, so it is named after its competition alone.
 */
export function posterName(tournamentName: string, match?: Match): string {
  return match ? `${tournamentName} v ${match.opponent}` : tournamentName;
}

/** The same name, reduced to something safe to save to disk. */
export function posterFileName(name: string): string {
  const slug = name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  return `${slug || 'poster'}.png`;
}
